module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Axe-27972f2b50470c48bc64980d6f0b72a1.svg";